module.exports = __webpack_public_path__ + "img/zy.81dcd663.png";